import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio as RadioComponent,
  FormLabel,
  FormHelperText,
  useTheme,
  RadioGroupProps,
  useMediaQuery
} from '@mui/material';
import { ReactNode } from 'react';
import { Controller, Control } from 'react-hook-form';

interface Props extends Omit<RadioGroupProps, 'name' | 'label'> {
  name: string;
  control: Control<any>;
  label?: string;
  disabled?: boolean;
  options: {
    label: string | ReactNode;
    value: string | number | boolean;
    disabled?: boolean;
    sx?: any;
  }[];
  formControlLabelSx?: any;
}

export default function Radio({
  name,
  control,
  label,
  options,
  formControlLabelSx,
  disabled,
  ...radioGroupProps
}: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const size = (radioGroupProps as any).size || (isLargeScreen ? 'medium' : 'small');

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <RadioGroup
              row={radioGroupProps.row ?? true}
              {...radioGroupProps}
              {...field}
              value={field.value === undefined || field.value === null ? '' : String(field.value)}
              onChange={(event, value) => {
                const matchedOption = options.find((optionItem) => String(optionItem.value) === value);
                const parsedValue = matchedOption ? matchedOption.value : value;
                field.onChange(parsedValue);
                radioGroupProps?.onChange?.(event, value);
              }}
            >
              {options.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={String(option.value)}
                  control={<RadioComponent size={size} />}
                  label={option.label}
                  disabled={disabled || option.disabled}
                  sx={{
                    margin: '8px 0',
                    ...formControlLabelSx,
                    ...option.sx
                  }}
                />
              ))}
            </RadioGroup>
            <FormHelperText sx={{ color: theme.palette.error.main }}>{error ? error.message : null}</FormHelperText>
          </>
        )}
      />
    </FormControl>
  );
}
